import React from 'react';
import { services, servicesContent } from '../data';
import { ServicesProps } from '../types';
import ServicesPresentation from './ServicesPresentation';

/**
 * Container component for the Services section
 * Responsible for data and state management
 */
const ServicesContainer: React.FC<ServicesProps> = ({ 
  className, 
  id = 'services' 
}) => {
  return (
    <ServicesPresentation
      id={id}
      heading={servicesContent.heading}
      description={servicesContent.description}
      services={services}
    />
  );
};

export default ServicesContainer;